import { InjectionToken } from '@angular/core';

export interface TamaroHostOptions {
  /** URL for the tamaro host iframe. */
  readonly url: string;
  /**
   * If `true` the session should be cleaned in Tamaro before
   * initialization.
   * Otherwise Tamaro will try to load the config based on data stored in
   * the session from previous payments.
   */
  readonly cleanupSession: boolean;
}

export const FMNTS_RAISENOW_TAMARO_HOST_OPTIONS =
  new InjectionToken<TamaroHostOptions>(
    '@formunauts/shared/vendors/raisenow/tamaro.host-options',
    {
      providedIn: 'root',
      factory: (): TamaroHostOptions => ({
        url: '/assets/tamaro.html',
        cleanupSession: true,
      }),
    },
  );
